__turbopack_context__.v({
  "header": "Pr9ERW_header",
  "header__right": "Pr9ERW_header__right",
  "shimmer": "Pr9ERW_shimmer",
  "text-bar-sweep": "Pr9ERW_text-bar-sweep",
  "title": "Pr9ERW_title",
  "title__logo": "Pr9ERW_title__logo",
  "title__placeholder": "Pr9ERW_title__placeholder",
});
